import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../environment';
import { AuthService } from '@common/services/AuthService/AuthService';
import { GetTasksOptions } from '@common/models/getTasksOptions.model';
import { AddTaskData } from '@common/models/addTaskData.model';
import { TaskDetails } from '@common/models/taskDetails.model';
import { TasksData } from '@common/models/tasksData.model';

@Injectable()
export class TaskService {
  constructor(
    private http: HttpClient,
    public authService: AuthService,
  ) {}

  addTask(areaKey: string, addTaskData: AddTaskData) {
    const endpoint = environment.endpoints.taskAdd;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    return this.http.post(
      `${endpoint}${companyKey}/${areaKey}/`,
      addTaskData,
      {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
      },
    );
  }

  getTaskDetails(taskKey: string): Observable<TaskDetails> {
    const endpoint = environment.endpoints.taskDetails;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    return this.http.get<TaskDetails>(
      `${endpoint}${companyKey}/${taskKey}/`,
      {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
      },
    );
  }

  editTask(taskKey: string, editTaskData: AddTaskData, editAll: boolean) {
    const endpoint = environment.endpoints.taskUpdate;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    return this.http.post(
      `${endpoint}${companyKey}/${taskKey}/`,
      editTaskData,
      {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
        params: new HttpParams()
          .set('editAll', editAll.toString()),
      },
    );
  }

  getTasks(options: GetTasksOptions): Observable<TasksData> {
    const endpoint = environment.endpoints.tasks;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();
    const queryParameters = options.queryParameters;

    let headers = new HttpHeaders()
      .set('Authorization', `Bearer ${accessToken}`)
      .set('language', navigator.language);

    let params = new HttpParams()
      .set('query', queryParameters.query)
      .set('orderBy', queryParameters.orderBy)
      .set('sortOrder', queryParameters.sortOrder)
      .set('page', queryParameters.page.toString());

    if (options.stateDate) {
      headers = headers.set('stateDate', options.stateDate);
    }

    if (options.employeeKey) {
      params = params.set('employeeKey', options.employeeKey);
    }

    return this.http.get<TasksData>(
      `${endpoint}${companyKey}/${options.areaKey}/`,
      {
        headers,
        params,
      },
    );
  }

  getForAddingTask(areaKey: string) {
    const endpoint = environment.endpoints.taskAddInfo;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    return this.http.get(
      `${endpoint}${companyKey}/${areaKey}/`,
      {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
      },
    );
  }

  deleteTask(taskKey: string, deleteAll: boolean | undefined) {
    const endpoint = environment.endpoints.taskDelete;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    let params = new HttpParams();

    if (deleteAll !== undefined) {
      params = params.set('deleteAll', deleteAll.toString());
    }

    return this.http.delete(
      `${endpoint}${companyKey}/${taskKey}/`,
      {
        params,
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
      },
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/TaskService/TaskService.ts